import * as React from 'react';

import Icon from '../Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const ClapActiveIcon: React.FC<Props> = props => {
  const size = props.size || 35;
  const color = props.color || '#f23406';
  return <Icon name={'project-clap-active'} size={size} color={color} />;
};

export default React.memo(ClapActiveIcon);
